//vendor libs

import 'jquery';
import 'slick-carousel';
import 'jquery-validation/dist/jquery.validate.min.js';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-mask-plugin';
import 'jquery-ui/ui/core.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/draggable.js';
import './libs/jquery.ui.touch-punch.js';
import './libs/jquery.datepicker.extension.range.min.js';
import 'jquery.cookie';
import './libs/selectize_custom.js';
import 'nanoscroller';
import 'iscroll';
import '@fancyapps/fancybox';
import './libs/jquery.panzoom_custom.js';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';

// vendor-styles
import 'normalize.css/normalize.css';
import 'slick-carousel/slick/slick.css';
import 'selectize-scss/src/selectize.scss';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import 'magnific-popup/dist/magnific-popup.css';


// WEBPACK FOOTER //
// ./vendor.js